import { createConnectQueryKey } from '@connectrpc/connect-query'
import {
  createBgMaster,
  listBgMasters,
} from '@ebalance/proto/bffuser/v1/occto_master_service-OcctoMasterService_connectquery'

import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/**
 * BG マスタ新規登録 mutation hook。
 * onSuccess で list query を invalidate してテーブルを最新化する。
 */
export function useCreateBgMaster(): InvalidatingMutationResultFor<
  typeof createBgMaster
> {
  return useInvalidatingMutation(createBgMaster, [
    createConnectQueryKey({ schema: listBgMasters, cardinality: 'finite' }),
  ])
}
